import React, { Component } from 'react';
import classes from './LoginForm.css';
import Button from '../../../components/UI/Button/Button';
import { Link } from 'react-router-dom';
import Input from '../../../components/UI/Input/Input';
import Spinner from '../../../components/UI/Spinner/Spinner';
import { updateObject } from '../../../shared/utilities';

class LoginForm extends Component {

  state = {
    formData: {
      email: {
        elementType: 'input',
        label: 'Email',
        size: 'whole',
        valid: false,
        touched: false,
        validation: {
          required: true,
          emailFormat: true
        },
        config: {
          id: 'email',
          value: '',
          type: 'text',
          placeholder: 'Email Address'
        }
      },
      password: {
        elementType: 'input',
        label: 'Password',
        size: 'whole',
        valid: false,
        touched: false,
        validation: {
          required: true,
          passwordFormat: true,
          minLength: 8
        },
        config: {
          id: 'password',
          value: '',
          type: 'password',
          placeholder: 'Password'
        }
      },
    },
    sendable: false,
    type: 'login'
  }


  updateForm = (input, value) => {
    const updatedFormData = updateObject(this.state.formData, { [input]: updateObject(this.state.formData[input], { config: updateObject(this.state.formData[input].config, { value: value }), valid: this.checkValidity(value, this.state.formData[input].validation) }) })

    const formComplete = this.validateForm(updatedFormData);
    this.setState({ formData: updatedFormData, sendable: formComplete })
  }

  submitCredentials = (event) => {
    event.preventDefault();
    if (this.state.sendable) {
      this.props.submitCredentials(this.state.formData.email.config.value, this.state.formData.password.config.value, this.state.type);
    } else {
      let updatedFormData = { ...this.state.formData };
      for (let element in updatedFormData) {
        updatedFormData[element].touched = true;
      }
      this.setState({ formData: updatedFormData })
    }
  }

  markTouched = (input) => {
    const updatedForm = updateObject(this.state.formData, { [input]: updateObject(this.state.formData[input], { touched: true }) })

    this.setState({ formData: updatedForm });
  }

  validateForm = (formData) => {
    let formIsValid = true;

    for (let formItem in formData) {
      formIsValid = formData[formItem].valid && formIsValid;
    }

    return formIsValid;
  }

  checkValidity(value, rules) {
    let isValid = false;
    let invalidChecks = [];
    if (rules.required) {
      if (value.trim() === '') {
        invalidChecks.push('required failed');
      };
    }

    if (rules.minLength) {
      if (value.length < rules.minLength) {
        invalidChecks.push('minLength failed')
      }
    }

    if (rules.maxLength) {
      if (value.length > rules.maxLength) {
        invalidChecks.push('maxLength failed')
      }
    }

    if (rules.passwordFormat) {
      let symbolRegex = /[!#$%&'@*+/=?^_`{|}~-]+/;
      let capitalRegex = /[A-Z]+/;
      let lowercaseRegex = /[a-z]+/
      if (!symbolRegex.test(value) || !capitalRegex.test(value) || !lowercaseRegex.test(value)) {
        invalidChecks.push('passwordFormat failed')
      }

    }

    if (rules.emailFormat) {
      let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
      if (!emailRegex.test(value)) {
        invalidChecks.push('emailFormat failed')
      }
    }

    if (invalidChecks.length === 0) {
      isValid = true;
    }
    return isValid;

  }

  render() {
    let inputs = [];


    for (let element in this.state.formData) {
      inputs.push(
        <Input update={this.updateForm}
          key={this.state.formData[element].config.id}
          config={this.state.formData[element].config}
          formGroupSize={this.state.formData[element].size}
          label={this.state.formData[element].label}
          inputType={this.state.formData[element].elementType}
          valid={this.state.formData[element].valid}
          touched={this.state.formData[element].touched}
          markTouched={this.markTouched}
          noLabel={true}
        />)
    }

    let form = <div className={classes.FormWrapper}>
      <h2 className={classes.Title}>Log in</h2>
      <form className={classes.LoginForm} onSubmit={(event) => { this.submitCredentials(event) }}>
        <div className={classes.Inputs}>
          {inputs}
          <Button type={'submit'} style={{ width: '90%', marginLeft: '0px' }} btnType={'Orange'} >Log in</Button>
        </div>
      </form>
      <p className={classes.ErrorMessage}>{this.props.errorMessage}</p>
      <p className={classes.SignupCTA}>Don't have an account? <span className={classes.CrossLink}><Link to='/authenticate/signup'>Sign up here.</Link></span></p>
    </div>


    return (
      <div className={classes.Card}>
        {this.props.loading ? <Spinner center={true} /> : form}
      </div >
    )
  }
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/containers/Auth/LoginForm/LoginForm.jsx